import i18n from 'i18n';
import { dateFilterParams } from '../../../shared/constants/index';

export default [
  {
    headerName: i18n.t('case.grid.caseName'),
    field: 'liId',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'liId',
  },
  {
    headerName: i18n.t('case.grid.warrantName'),
    field: 'warrantId.name',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'warrantId.name',
  },
  {
    headerName: i18n.t('case.grid.caseState'),
    field: 'subStatus',
    sortable: true,
    filter: 'agSetColumnFilter',
    resizable: true,
    floatingFilter: true,
    tooltipField: 'subStatus',
    filterParams: {
      values: ['NOTYETSTARTED', 'ACTIVE', 'STOPPED', 'PAUSED', 'EXPIRED'],
    },
  },
  {
    headerName: i18n.t('case.grid.startTime'),
    field: 'startDateTime',
    sortable: true,
    filter: 'agDateColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'startDateTime',
    filterParams: dateFilterParams,
    cellRenderer: 'DateTimeWithTimezoneCellRenderer',
  },
  {
    headerName: i18n.t('case.grid.stopTime'),
    field: 'stopDateTime',
    sortable: true,
    filter: 'agDateColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'stopDateTime',
    filterParams: dateFilterParams,
    cellRenderer: 'DateTimeWithTimezoneCellRenderer',
  },
  {
    headerName: i18n.t('case.grid.timeZone'),
    field: 'timeZone',
    sortable: false,
    resizable: true,
    tooltipField: 'timeZone',
    floatingFilter: true,
    cellRenderer: 'TimeZoneCellRenderer',
  },
  {
    headerName: i18n.t('case.grid.provisionStatus'),
    field: 'reporting.provisionStatus',
    sortable: false,
    floatingFilter: true,
    filter: 'agSetColumnFilter',
    resizable: true,
    tooltipField: 'reporting.provisionStatus',
    filterParams: {
      values: [
        'FAILED',
        'DELETED',
        'SCHEDULED',
        'PROVISIONED',
        'TRANSITIONING',
      ],
    },
  },
  {
    headerName: i18n.t('case.grid.collectionFunction'),
    field: 'cfId.name',
    sortable: true,
    floatingFilter: true,
    filter: 'agTextColumnFilter',
    resizable: true,
    tooltipField: 'cfId.name',
  },
  {
    headerName: i18n.t('case.grid.numberPacketsMediated'),
    field: 'reporting.packetsMediated',
    sortable: true,
    floatingFilter: true,
    filter: 'agNumberColumnFilter',
    resizable: true,
    tooltipField: 'reporting.packetsMediated',
    hide: true,
  },
];
